import styled from 'styled-components';
import { getCombinedClassNames } from 'utils/style';

const QNavWrapElem = styled.div.attrs({})``;
const QNavTitleElem = styled.h2.attrs(() => {
  const classNamesToAdd = ['h3', 'mb-4', 'lg:mb-8', 'text-basic-700'];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;

const QNavListElem = styled.div.attrs(() => {
  const classNamesToAdd = [
    'md:flex',
    'md:p-4',
    'md:border-4',
    'md:border-solid',
    'md:border-basic-300',
    'md:rounded-lg',
    'border-none',
  ];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;
const QNavListItemElem = styled.div.attrs(() => {
  const classNamesToAdd = [
    'lg:h-20',
    'md:w-1/4',
    'md:h-16',
    'md:flex-row',
    'md:items-center',
    'md:justify-center',
    'md:my-0',
    'md:last:border-r-0',
    'md:border-basic-300',
    'md:border-r-4',
    'md:border-b-0',
    'md:border-l-0',
    'md:border-t-0',
    'md:rounded-none',
    'md:break-words',
    'w-full',
    'flex',
    'flex-col',
    'border-solid',
    'border-2',
    'border-primary',
    'rounded-full',
    'my-3',
    'py-1',
    'px-3',
    'text-center',
  ];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;

const QNavAnchorElem = styled.a.attrs(() => {
  const classNamesToAdd = [
    'lg:text-xl',
    'md:font-extrabold',
    'transition-colors',
    'hover:text-opacity-80',
    'active:text-opacity-60',
    'duration-200',
    'ease-in-out',
    'cursor-pointer',
    'text-primary',
    'visited:text-opacity-60',
    'text-base',
    'font-semibold',
  ];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;

export { QNavWrapElem, QNavTitleElem, QNavListElem, QNavListItemElem, QNavAnchorElem };
